import React from 'react';
export function SocialProof() {
  const stats = [{
    icon: '👯',
    value: '5k+',
    label: 'Instructoras'
  }, {
    icon: '🏫',
    value: '800+',
    label: 'Academias'
  }, {
    icon: '📄',
    value: '120k+',
    label: 'Descargas'
  }, {
    icon: '⏰',
    value: '94%',
    label: 'Ahorro Tiempo'
  }];
  return <section className="bg-white py-8 px-4 border-y border-brand-border" data-id="element-265">
      <div className="max-w-5xl mx-auto" data-id="element-266">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-267">
          {stats.map((stat, i) => <div key={i} className="flex flex-col items-center" data-id="element-268">
              <div className="text-3xl mb-2" data-id="element-269">{stat.icon}</div>
              <div className="font-display text-2xl font-bold text-brand-title mb-1" data-id="element-270">
                {stat.value}
              </div>
              <div className="text-xs text-brand-textMuted uppercase tracking-wider font-medium" data-id="element-271">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}